import React from 'react';
import clsx from 'clsx';

import css from './Image.module.scss';

interface Props {
    src: string;
    alt?: string;
    circled?: boolean;
    toastImage?: boolean;
    className?: string;
    onClick?: () => void;
}

const Image: React.FC<Props> = ({ src, alt = '', circled = true, toastImage = false, className, onClick }) => (
    <img
        className={clsx(css.image, circled && css.circled, toastImage && css.toastImage, className && className)}
        src={src}
        alt={alt}
        onClick={onClick}
    />
);

export default React.memo(Image);
